import { enumFillMode, enumPanelBorderStyle } from "../constants";
import { QFieldElement } from "./QFieldElement";
import { QPanel } from "./QPanel";

export class QFieldDraggerPanel extends QPanel {
  constructor() {
    super();
    this.fFieldElement = null;
    this.fDestPanel = null;
    this.fFieldDef = null;
    this.fIsFreeText = null;
    this.fSourceElement = null;
    this.fRenderPhoenix = true;
  }

  InitFieldDraggerPanel(
    aFieldDef,
    isFreeText,
    sourceElement,
    sx,
    sy,
    maxWidth,
    height,
    sourcePanel,
    destPanel,
    releaseCmd,
    imageMgr
  ) {
    this.fSourceElement = sourceElement;
    this.PositionPanel(sx, sy);
    this.SizePanel(maxWidth, height);

    // Optimization because element is the same size as the panel
    this.SetFillMode(enumFillMode.noFill);
    this.SetBorderRadius(4);
    this.SetBorderStyle(enumPanelBorderStyle.roundBorder);
    this.fFieldElement = new QFieldElement();
    this.fFieldElement.InitFieldElement(aFieldDef, sourcePanel, this, false, isFreeText, imageMgr);
    this.fFieldElement.SetFillColor("#CAE5FF");

    var theWidth = this.fFieldElement.CalculateWidth(this.fOffscreenBuffer);
    if (theWidth > maxWidth) theWidth = maxWidth;

    this.SetAlpha(0.9);
    this.SizePanel(theWidth, height);
    this.fFieldElement.PositionElement(0, 0);
    this.fFieldElement.SizeElement(theWidth, height);
    this.fFieldElement.SetControlReleaseCmdCode(releaseCmd);
    this.PushElement(this.fFieldElement);
    this.fDestPanel = destPanel;
    this.fFieldDef = aFieldDef;
    this.fIsFreeText = isFreeText;
  }

  GetSourceElement() {
    return this.fSourceElement;
  }

  GetFieldElement() {
    return this.fFieldElement;
  }

  SetDragStart(x, y) {
    var xPanel = this.GetLocalX(x);
    var yPanel = this.GetLocalY(y);
    this.fFieldElement.StartInteractWithElement(x, y, xPanel, yPanel, false);
  }

  PrepInteractWithElement(controlElement, x, y) {}

  DragComplete() {}
}
